<div class="titleSpacerBelow">&nbsp;</div>

<div class="sectionContainer clientAddress">
  <div class="client-sub-title expandable" (click)="addressExpanded = !addressExpanded" [class.expanded]="addressExpanded">
    <span>Client Address</span>
    <span class="expand-indicator">{{ addressExpanded ? '▾' : '▸' }}</span>
  </div>

  <div class="subscription-items" *ngIf="addressExpanded">
    <table class="subscription-items-table">
      <thead>
        <tr>
          <th>AddressLine</th>
          <th>Town</th>
          <th>County</th>
          <th>PostCode</th>
          <th>Country</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="clientContact && (clientContact.isEdit || clientContact.address || clientContact.town || clientContact.postcode || clientContact.country || clientContact.county || clientContact.name)">
          <td>
            <ng-container *ngIf="clientContact?.isEdit; else showAddressLine">
              <input class="input-name" type="text" [(ngModel)]="clientContact.address" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </ng-container>

            <ng-template #showAddressLine>
              {{ clientContact?.address }}
            </ng-template>
          </td>

          <td>
            <ng-container *ngIf="clientContact?.isEdit; else showTown">
              <input type="text" [(ngModel)]="clientContact.town" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #showTown>
              {{ clientContact?.town }}
            </ng-template>
          </td>

          <td>
            <ng-container *ngIf="clientContact?.isEdit; else showAddressLine2">
              <input class="input-name" type="text" [(ngModel)]="clientContact.county" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </ng-container>

            <ng-template #showAddressLine2>
              {{ clientContact?.county }}
            </ng-template>
          </td>

          <td>
            <ng-container *ngIf="clientContact?.isEdit; else showPostCode">
              <input type="text" [(ngModel)]="clientContact.postcode" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #showPostCode>
              {{ clientContact?.postcode }}
            </ng-template>
          </td>

          <td>
            <ng-container *ngIf="clientContact?.isEdit; else showCountry">
              <input type="text" [(ngModel)]="clientContact.country" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #showCountry>
              {{ clientContact?.country }}
            </ng-template>
          </td>

          <td class="client-actions" (click)="$event.stopPropagation()">
            <ng-container *ngIf="clientContact?.isEdit; else actionsView">
              <button mat-icon-button (click)="cancelClientEdit()">
                <mat-icon>cancel</mat-icon>
              </button>
              <button mat-icon-button (click)="saveClientAddress()">
                <mat-icon>save</mat-icon>
              </button>
            </ng-container>

            <ng-template #actionsView>
              <button mat-icon-button (click)="editClientAddress()">
                <mat-icon>edit</mat-icon>
              </button>
            </ng-template>
          </td>
        </tr>

        <tr *ngIf="clientContact && !clientContact.isEdit && !(clientContact.address || clientContact.town || clientContact.postcode || clientContact.country || clientContact.county || clientContact.name)">
          <td colspan="7" style="text-align:center; padding:16px;">
            No address available for this client.
            <div style="margin-top:8px;">
              <button mat-raised-button color="primary" (click)="addAddress()">Add Address</button>
            </div>
          </td>
        </tr>

        <tr *ngIf="!clientContact">
          <td colspan="7" style="text-align:center; padding:16px;">
            No client data available.
            <div style="margin-top:8px;">
              <button mat-raised-button color="primary" (click)="addAddress()">Add Address</button>
            </div>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>

<div class="sectionContainer contacts">
  <div class="client-sub-title expandable" (click)="contactsExpanded = !contactsExpanded" [class.expanded]="contactsExpanded">
    <span>Contacts</span>
    <span class="expand-indicator">{{ contactsExpanded ? '▾' : '▸' }}</span>
  </div>

  <div class="subscription-items" *ngIf="contactsExpanded">

    <div class="items-scroll-wrapper">
      <table class="subscription-items-table">
        <thead>
          <tr>
            <th>ForeName</th>
            <th>Surname</th>
            <th>Job Title</th>
            <th>Group Name</th>
            <th>Email</th>
            <th>Telephone</th>
            <th>Tableau Login</th>
            <th *ngIf="isAnyContactEditing">Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contact of contacts; let i = index">
            <td>
              <ng-container *ngIf="contact.isEdit; else showForeName">
                <input class="input-name" type="text" [(ngModel)]="contact.forename" [disabled]="!!contact.isGroupType" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>

              <ng-template #showForeName>
                {{ !contact.groupName ? contact.forename : '' }}
              </ng-template>
            </td>

            <td>
              <ng-container *ngIf="contact.isEdit; else showSurName">
                <input class="input-name" type="text" [(ngModel)]="contact.surname" [disabled]="!!contact.isGroupType" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>

              <ng-template #showSurName>
                {{ !contact.groupName ? contact.surname : '' }}
              </ng-template>
            </td>

            <td>
              <ng-container *ngIf="contact.isEdit; else showTitle">
                <input type="text" [(ngModel)]="contact.jobTitle" [disabled]="!!contact.isGroupType" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>
              <ng-template #showTitle>
                {{ contact.jobTitle }}
              </ng-template>
            </td>

            <td>
              <ng-container *ngIf="contact.isEdit; else showGroupName">
                <input type="text" [(ngModel)]="contact.groupName" [disabled]="!contact.isGroupType" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>
              <ng-template #showGroupName>
                {{ contact.groupName }}
              </ng-template>
            </td>

            <td class="email-cell">
              <ng-container *ngIf="contact.isEdit; else showEmail">
                <input type="text" [(ngModel)]="contact.email" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>
              <ng-template #showEmail>
                {{ contact.email }}
              </ng-template>
            </td>

            <td>
              <ng-container *ngIf="contact.isEdit; else showTelephone">
                <input type="text" [(ngModel)]="contact.telephone" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </ng-container>
              <ng-template #showTelephone>
                {{ contact.telephone }}
              </ng-template>
            </td>

            <td class="has-login-cell" (click)="$event.stopPropagation()">
              <ng-container *ngIf="contact.isEdit; else showHasLogin">
                <input type="checkbox" [(ngModel)]="contact.hasLogin" (click)="$event.stopPropagation()" />
              </ng-container>
              <ng-template #showHasLogin>
                {{ contact.hasLogin ? 'Y' : 'N' }}
              </ng-template>
            </td>

            <td *ngIf="isAnyContactEditing" class="contact-type-cell" (click)="$event.stopPropagation()">
              <ng-container *ngIf="contact.isEdit">
                <div class="contact-type-toggle">
                  <span class="toggle-label" [class.active]="!contact.isGroupType">Person</span>
                  <label class="toggle-switch">
                    <input type="checkbox" [checked]="contact.isGroupType" (change)="contact.isGroupType = !contact.isGroupType; onContactTypeChange(contact)" />
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="toggle-label" [class.active]="contact.isGroupType">Group</span>
                </div>
              </ng-container>
            </td>

            <td class="client-actions" (click)="$event.stopPropagation()">
              <ng-container *ngIf="contact.isEdit; else actionsView">
                <button mat-icon-button (click)="cancelContactEdit(contact)">
                  <mat-icon>cancel</mat-icon>
                </button>
                <button mat-icon-button (click)="saveContact(contact)">
                  <mat-icon>save</mat-icon>
                </button>
              </ng-container>

              <ng-template #actionsView>
                <button mat-icon-button (click)="editContact(contact)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteContact(contact)">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="addUserButtonContainer">
      <button mat-raised-button class="addButton" (click)="addContact()">
        Add Contact
      </button>
    </div>

  </div>

</div>

<div class="sectionContainer subscriptions">

  <div class="client-sub-title expandable" (click)="subscriptionsExpanded = !subscriptionsExpanded" [class.expanded]="subscriptionsExpanded">
    <span>Subscriptions</span>
    <span class="expand-indicator">{{ subscriptionsExpanded ? '▾' : '▸' }}</span>
  </div>

  <div class="subscription-items" *ngIf="subscriptionsExpanded">

    <div class="subscription-header-row">
      <div>Service Type</div>
      <div>StartDate</div>
      <div>EndDate</div>
      <div>Invoice Frequency</div>
      <div>Notification Contact</div>
      <div>Client PO</div>
      <div>Notes</div>
      <div>ReportHads</div>
      <div>Max Notify Months</div>
      <div>Active</div>
      <div>Action</div>
    </div>

    <mat-accordion>

      <mat-expansion-panel *ngFor="let sub of subscriptions; let i = index"
                           class="subscription-panel"
                           [ngClass]="'service-style-' + ((getServiceStyleIndex(sub.serviceTypeId)) ||1)"
                           [class.inactive]="!isSubscriptionActive(sub)"
                           [class.active]="isSubscriptionActive(sub)"
                           [class.expanded]="sub.showItems"
                           [expanded]="sub.showItems"
                           [hideToggle]="sub.id <= 0"
                           [disabled]="sub.id <= 0"
                           (opened)="sub.showItems = true"
                           (closed)="sub.showItems = false">
        <mat-expansion-panel-header>
          <div class="panel-header-grid" [class.new-sub-padding]="sub.isEdit">
            <div>
              <div *ngIf="sub.isEdit && sub.id <=0">
                <mat-form-field style="width:70%;margin-top:11%; text-align:center;padding:0" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                  <mat-select [(ngModel)]="sub.serviceTypeId" (selectionChange)="onServiceTypeChange(sub)" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                    <mat-option *ngFor="let st of getAvailableServiceTypes(sub)" [value]="st.id">{{ st.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!sub.isEdit || (sub.isEdit && sub.id >0)" class="service-text">
                {{ getServiceTypeName(sub.serviceTypeId) }}
              </div>
            </div>

            <div>
              <div *ngIf="sub.isEdit && sub.id <=0">
                <mat-form-field style="width:80%;margin-top:8%;" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                  <input matInput [matDatepicker]="startPicker" [(ngModel)]="sub.startDate" (dateChange)="onStartDateChange($event, sub)" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                  <mat-datepicker-toggle matIconSuffix [for]="startPicker" (click)="stopEvent($event)"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="!(sub.isEdit && sub.id <=0)" class="active-text">
                {{ sub.startDate | date:'dd/MM/yyyy' }}
              </div>
            </div>

            <div class="active-text">
              {{ sub.endDate | date:'dd/MM/yyyy' }}
            </div>

            <div>
              <div *ngIf="sub.isEdit">
                <mat-form-field style="width:70%;margin-top:11%; text-align:center" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                  <mat-select [(ngModel)]="sub.invoiceFrequency" (click)="stopEvent($event)" (keydown)="stopKey($event)">
                    <mat-option *ngFor="let st of getInvoiceFrequency()" [value]="st.code">{{ st.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!sub.isEdit" class="service-text">
                {{ getInvoiceFrequencyName(sub.invoiceFrequency) }}
              </div>
            </div>

            <div>
              <div *ngIf="sub.isEdit">
                <mat-form-field style="width:100%; margin-top:8%;">
                  <mat-select multiple [(ngModel)]="sub.notificationContacts" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" placeholder="Select contacts">
                    <mat-option *ngFor="let person of contacts" [value]="person.id">{{ person.groupName || (person.forename + ' ' + person.surname) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!sub.isEdit" class="service-text">
                {{ getContactNamesForSubscription(sub) || 'No contacts' }}
              </div>
            </div>

            <div>
              <div *ngIf="sub.isEdit">
                <input type="text" [(ngModel)]="sub.purchaseOrderReference" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </div>
              <div *ngIf="!sub.isEdit" class="service-text">
                {{ sub.purchaseOrderReference}}
              </div>
            </div>

            <div>
              <div *ngIf="sub.isEdit">
                <input type="text" class="notes-input" maxlength="1000" [(ngModel)]="sub.notes"
                       [title]="sub.notes || ''" placeholder="Notes..."
                       (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                       (dblclick)="openNotesPopup(sub); $event.stopPropagation()" />
              </div>
              <div *ngIf="!sub.isEdit" class="service-text notes-preview" [title]="sub.notes || ''">
                {{ sub.notes }}
              </div>
            </div>

            <div>
              <ng-container *ngIf="sub.isEdit; else hadsView">
                <mat-checkbox [(ngModel)]="sub.reportHads"
                              [disabled]="!isNamedService(sub.serviceTypeId)"
                              (click)="$event.stopPropagation()">
                  
                </mat-checkbox>
              </ng-container>

              <ng-template #hadsView>
                <span class="service-text">
                  {{ isNamedService(sub.serviceTypeId) ? (sub.reportHads ? 'Yes' : 'No') : '-' }}
                </span>
              </ng-template>
            </div>

            <div>
              <div *ngIf="sub.isEdit">
                <input type="number" min="0" step="1" inputmode="numeric"
                       [(ngModel)]="sub.maxNotificationAgeInMonths"
                       (click)="$event.stopPropagation()"
                       (keydown)="$event.stopPropagation()"
                       (keypress)="onMaxProcessAgeKeyPress($event)" />
              </div>
              <div *ngIf="!sub.isEdit" class="service-text">
                {{ sub.maxNotificationAgeInMonths ?? '' }}
              </div>
            </div>

            <div>
              <div class="active-text">
                {{ (sub.endDate === null || sub.endDate === undefined) ? 'Active' : 'Inactive' }}
              </div>
            </div>

            <div *ngIf="!sub.showItems && !sub.isEdit">
              <div style="display: flex; gap:8px;">
                <button type="button" mat-icon-button aria-label="Edit" (click)="$event.stopPropagation(); editSubscription(sub)" matTooltip="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-icon-button aria-label="Deactivate" (click)="$event.stopPropagation(); unsubscribeSubscription(sub)" [disabled]="!isSubscriptionActive(sub)" matTooltip="Cancel Subscription">
                  <mat-icon>block</mat-icon>
                </button>
              </div>
            </div>

            <div *ngIf="!sub.showItems && sub.isEdit">
              <div style="display: flex; gap:8px;">
                <button type="button" mat-icon-button aria-label="Save Subscription" (click)="$event.stopPropagation(); saveSubscription(sub)" matTooltip="Save" [disabled]="!isSubscriptionValid(sub)">
                  <mat-icon>save</mat-icon>
                </button>
                <button type="button" mat-icon-button aria-label="Cancel" (click)="$event.stopPropagation(); cancelAddSubscription(sub)" matTooltip="Cancel">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </mat-expansion-panel-header>

        <div class="subscription-items">
          <app-admin-subscription-items [subscriptionId]="sub.id" [serviceTypeId]="sub.serviceTypeId" [loggedInUser]="loggedInUser"></app-admin-subscription-items>
        </div>
      </mat-expansion-panel>

    </mat-accordion>

    <div class="addUserButtonContainer" *ngIf="!anyExpanded">
      <button mat-raised-button class="addButton" (click)="addSubscription()" [disabled]="isAddDisabled()">
        Add Subscription
      </button>
    </div>

  </div>

  <!-- Expanded Notes editor - mirrors the Benham Clause / Footer "double-click to expand" popup -->
  <div class="notes-popup-overlay" *ngIf="isNotesPopupOpen" (mousedown)="onNotesPopupOverlayMouseDown($event)">
    <div class="notes-popup-dialog" cdkDrag cdkDragBoundary=".notes-popup-overlay" (click)="$event.stopPropagation()">
      <div class="notes-popup-header" cdkDragHandle>
        <h3>Subscription Notes</h3>
        <button class="close-btn" (click)="closeNotesPopup()" title="Close">✕</button>
      </div>
      <div class="notes-popup-content">
        <textarea class="notes-textarea" [(ngModel)]="notesPopupValue" maxlength="1000"
                  placeholder="Enter notes here..." rows="12"></textarea>
      </div>
      <div class="notes-popup-footer">
        <button class="btn btn-secondary" (click)="closeNotesPopup()">Cancel</button>
        <button class="btn btn-primary" (click)="applyNotesPopup()">Apply</button>
      </div>
    </div>
  </div>

</div>

<div class="sectionContainer invoices">
  <div class="client-sub-title expandable" (click)="invoicesExpanded = !invoicesExpanded" [class.expanded]="invoicesExpanded">
    <span>Invoice History</span>
    <span class="expand-indicator">{{ invoicesExpanded ? '▾' : '▸' }}</span>
  </div>

  <div class="subscription-items" *ngIf="invoicesExpanded">

    <div class="items-scroll-wrapper">
      <table class="subscription-items-table">
        <thead>
          <tr>
            <th>Created Date</th>
            <th>Finance Invoice Number</th>
            <th>Subscription Name</th>
            <th>Purchase Order Reference</th>
            <th>Notification Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoice of invoicess; let i = index">
            <td>{{ invoice.createdDate | date:'dd/MM/yyyy' }}</td>
            <td>{{ invoice.financeInvoiceNumber }}</td>
            <td>{{ invoice.subscriptionName }}</td>
            <td>{{ invoice.purchaseOrderReference }}</td>
            <td>{{ invoice.notificationCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>

<div class="sectionContainer notifications">
  <div class="client-sub-title expandable" (click)="notificationsExpanded = !notificationsExpanded" [class.expanded]="notificationsExpanded">
    <span>Notification History</span>
    <span class="expand-indicator">{{ notificationsExpanded ? '▾' : '▸' }}</span>
  </div>

  <div class="subscription-items" *ngIf="notificationsExpanded">

    <div class="notification-controls">
      <input type="text"
             class="notification-search-input"
             placeholder="Search by probate ID, name, service type, date or invoice..."
             [(ngModel)]="notificationSearchTerm"
             (input)="filterNotifications()" />
      <mat-paginator [length]="filteredNotifications.length"
                     [pageSize]="notificationPageSize"
                     [pageIndex]="notificationPageIndex"
                     [pageSizeOptions]="notificationPageSizeOptions"
                     (page)="notificationPageChanged($event)"
                     showFirstLastButtons>
      </mat-paginator>
    </div>

    <div class="items-scroll-wrapper">
      <table class="subscription-items-table notification-table">
        <thead>
          <tr>
            <th>Probate Id</th>
            <th><div style="display: inline-block; min-width: 220px; text-align: left;">Deceased Name</div></th>
            <th>Service Type</th>
            <th>Client Emailed Date</th>
            <th>Invoice No</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let notification of paginatedNotifications">
            <td>{{ notification.probateId }}</td>
            <td>
              <div style="display: inline-block; min-width: 220px; text-align: left;">
                {{ notification.deceasedName }}
              </div>
            </td>
            <td>{{ notification.serviceTypeName }}</td>
            <td>{{ notification.clientEmailedDate | date:'dd/MM/yyyy' }}</td>
            <td>{{ notification.invoiceId }}</td>
            <td>
              <button *ngIf="!notification.paymentCancelledDate"
                      mat-stroked-button
                      class="cancel-payment-btn"
                      (click)="cancelPayment(notification)">
                Cancel Payment
              </button>
              <button *ngIf="notification.paymentCancelledDate"
                      mat-stroked-button
                      class="uncancel-payment-btn"
                      (click)="uncancelPayment(notification)">
                Uncancel Payment
              </button>
            </td>
          </tr>
          <tr *ngIf="filteredNotifications.length === 0">
            <td colspan="6" style="text-align:center; padding:16px; color:#888;">No notifications found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="results-count" style="padding: 8px 4px; font-size:12px; color:#666;">
      Showing {{ paginatedNotifications.length }} of {{ filteredNotifications.length }} record(s)
      <ng-container *ngIf="notificationSearchTerm"> (filtered from {{ notifications.length }} total)</ng-container>
    </div>

  </div>
</div>
